import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SubscriptionRoute = () => {
  const { user } = useSelector((state) => state.auth);

  const isExpired =
    user?.subscriptionExpiry &&
    new Date(user.subscriptionExpiry).setHours(23, 59, 59, 999) < Date.now();

  if (user && (!user.is_active || isExpired)) {
    return (
      <div className="p-12 text-center text-red-600">
        <h2 className="text-2xl font-bold">Account Inactive</h2>
        <p className="mt-2 text-red-500">
          Your subscription has expired or your account has been deactivated. Please contact support.
        </p>
        <button
          onClick={() => window.location.href = 'mailto:support@example.com'}
          className="mt-6 px-6 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors shadow-md"
        >
          Contact Support
        </button>
      </div>
    );
  }

  return <Outlet />;
};

export default SubscriptionRoute;